import {Currency} from "./chatbotSlice";

export const prepareCurrencyCode = (currency?: Currency): string => {
    switch (currency) {
        case Currency.Pound:
            return 'gbp'
        default:
            throw new Error(`Unable to handle reservation currency: ${currency}`)
    }
}

export const prepareCurrencySign = (currency?: Currency): string => {
    switch (currency) {
        case Currency.Pound:
            return '£'
        default:
            throw new Error(`Unable to handle reservation currency: ${currency}`)
    }
}

export const prepareReservationPrice = (price?: number) => {
    if (price) {
        return Math.round(price * 100)
    } else {
        throw new Error(`Unable to handle reservation price: ${price}`)
    }
}

export const getFullPriceString = (price?: number, currency?: Currency) => {
    return `${prepareCurrencySign(currency)}${price}`
}
